import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ n, label, dark = false }) => (
  <Reveal className="mb-10 flex items-center gap-5">
    <span className={`font-mono text-xs tracking-[0.3em] ${dark ? "text-[#C8564D]" : "text-inkred"}`}>{n}</span>
    <span className="gold-hairline w-16" aria-hidden="true" />
    <span className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-mist" : "text-bodylight"}`}>
      {label}
    </span>
  </Reveal>
);
